import { configureStore } from "@reduxjs/toolkit";
import { users, Users } from "./reducer/users";

export interface ReduxState {
  users: Users;
}

export default configureStore<ReduxState>({
  reducer: {
    users: users.reducer,
  },
});
